import { createContext } from 'react';
import { PopupApi, PopupWithId } from './Popup/type';

export const PopupManagerContext = createContext<{
  register: (popup: PopupWithId) => void;
  unregister: (id: string) => void;
}>({} as any);

export const CurrentPopupContext = createContext<PopupApi<any>>({} as any);
